"use client";

import CouponSidebar from "@/components/shared/coupon-sidebar";
import DeleteBooking from "@/components/shared/delete-booking";
import PageTitle from "@/components/shared/page-title";
import WANotice from "@/components/shared/wa-notice";
import Whatsapp from "@/components/shared/whatsapp";
import { Button } from "@/components/ui/button";
import { TCouponCategory } from "@/types/coupon";
import { TEvent } from "@/types/event";
import { TSettings } from "@/types/settings";
import Image from "next/image";
import { useRouter } from "next/navigation";
import { useState } from "react";

export default function CouponContainer({
  couponCategories,
  events,
  settings,
}: {
  couponCategories: TCouponCategory[];
  events: TEvent[];
  settings: TSettings;
}) {
  const router = useRouter();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarCouponCategory, setSidebarCouponCategory] =
    useState<TCouponCategory | null>(null);
  const [showWANotice, setShowWANotice] = useState(false);

  return (
    <div className="w-full">
      <DeleteBooking />
      <PageTitle title="Vales regalo" />

      <div className="pt-40">
        <Button
          variant={"outline"}
          className="mt-8"
          onClick={() => router.push("/")}
        >
          {"< "} Volver al calendario
        </Button>
        {/* TODO bring this back */}
      </div>

      <div className={showWANotice ? "mb-2 mb-6 sm:mb-12" : ""}>
        <WANotice setShowWANotice={setShowWANotice} callback={() => {}} />
      </div>

      <div className="flex justify-center mt-8">
        <div className="mt-4 inline-flex gap-6 flex-wrap cursor-pointer justify-center">
          {(couponCategories || []).map((activity, key) => (
            <div
              key={activity.id || key}
              className="sm:w-[45%] lg:w-[30%] overflow-hidden radius-base flex flex-row sm:flex-col justify-center relative"
            >
              <Image
                src={
                  activity.image ||
                  activity.activityCategories?.[0]?.image ||
                  ""
                }
                width={400}
                height={300}
                className="w-full max-w-[30%] sm:max-w-none h-auto object-cover"
                alt=""
                unoptimized={true}
              />
              <div className="absolute top-2 right-2 bg-secondary-text text-md font-bold text-muted pt-1 pb-1 pl-3 pr-3 rounded-full">
                {activity.packs ? "Desde " : ""}
                {activity.activityCategories &&
                activity.activityCategories.length > 0
                  ? activity.price
                  : Math.min(
                      ...(activity.packs || [])
                        .filter((p) => p.isPubliclyVisible)
                        .map((p) => p.price)
                    )}
                €
              </div>
              <div
                className="p-4 text-center"
                style={{
                  backgroundColor:
                    activity.activityCategories?.[0]?.color ||
                    "var(--primary-text)",
                }}
              >
                <h2 className="font-domine text-lg font-bold mt-10 sm:mt-0">
                  {activity.title}
                  {/* {activity.activityCategory
                    ? activity.activityCategory.title !== activity.title
                      ? " ~ " + activity.activityCategory.title
                      : ""
                    : ""} */}
                </h2>
                <p dangerouslySetInnerHTML={{ __html: activity.subtitle }}></p>
                <div className="p-2 flex justify-center">
                  <Button
                    className="max-w-[90%] flex-wrap whitespace-normal h-auto"
                    onClick={() => {
                      setSidebarCouponCategory(activity);
                      setSidebarOpen(true);
                    }}
                  >
                    Más información y comprar vale
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div
        className={
          "fixed top-0 right-0 h-full transform transition-transform duration-500 ease-in-out z-10 ml-4 border-l-1 w-[360px] bg-muted shadom-md overflow-auto " +
          (sidebarOpen ? "translate-x-0" : "translate-x-full")
        }
      >
        <CouponSidebar
          events={events}
          settings={settings}
          couponCategory={sidebarCouponCategory}
          onClose={() => setSidebarOpen(false)}
        />
      </div>

      <div
        className={
          "fixed bottom-3 right-4 rounded-full z-99 animate-[bounce-once_1s_ease-out_3]"
        }
      >
        <Whatsapp />
      </div>
    </div>
  );
}
